import Enlang from './entries/en-US';
import Rslang from './entries/sr-RS';

const AppLocale = {
  en: Enlang,
  sr: Rslang,
};

export default AppLocale;
